import React, { useEffect, useState } from 'react'

import { EuiSelectableOption } from '@elastic/eui/src/components/selectable/selectable_option'

import { Account } from '../../api/interfaces'
import { useGetAccountsQuery } from '../../api/rtkQueryApi/platform/accountsApi'
import { AcSearchSelector } from '../Basic/AcSearchSelector'
import { ClientCreateModal } from './ClientCreateModal'

export interface IClientPicker {
  selectedClient?: Account
  onClientChange: (client: Account) => void
  enableNewClient?: boolean
}

export const ClientPicker: React.FC<IClientPicker> = props => {
  const [accountOptions, setAccountOptions] = useState<EuiSelectableOption[]>([])
  const accountsGetQuery = useGetAccountsQuery({})
  const [showNewClientModal, setShowNewClientModal] = useState(false)

  useEffect(() => {
    if (accountsGetQuery.data) {
      const accounts = accountsGetQuery.data
      setAccountOptions(
        accounts.map(a => ({
          label: a.name,
          checked: a.id === props.selectedClient?.id ? 'on' : undefined,
          key: a.id
        }))
      )
    }
  }, [accountsGetQuery.data, props.selectedClient])

  const onSelectAccount = (accountId: string) => {
    const account = accountsGetQuery.data?.find(a => a.id === accountId)
    if (!account) {
      return
    }
    props.onClientChange(account)
  }

  const onNewClientClick = () => {
    setShowNewClientModal(true)
  }

  const isAccountsLoading = accountsGetQuery.isLoading || accountsGetQuery.isFetching

  return (
    <>
      <AcSearchSelector
        displayedText={accountsGetQuery.data?.find(a => a.id === props.selectedClient?.id)?.name ?? ''}
        options={accountOptions}
        showSearch={accountOptions.length > 4}
        isLoading={isAccountsLoading}
        onOptionSelected={option => {
          if (option.key) {
            onSelectAccount(option.key)
          }
        }}
        newButton={props.enableNewClient ? { text: 'Create New Client +', onClick: onNewClientClick } : undefined}
      />
      {props.enableNewClient && showNewClientModal && (
        <ClientCreateModal
          onClientCreated={() => {
            setShowNewClientModal(false)
          }}
          onCancel={() => setShowNewClientModal(false)}
        />
      )}
    </>
  )
}
